import { ApiChatbotFeedbackResponseInterface } from '../interfaces/api';
import { ChatbotFeedbackInterface } from '../interfaces/chatbot-feedback.interface';

export function mapFeedbackResponse(response: ApiChatbotFeedbackResponseInterface): ChatbotFeedbackInterface {
    return {
        success: response.result?.toLowerCase() === 'ok',
        message: response.Message,
    };
}
